<template>
  <div class="container" id="defineTask">
    <navigation-drawer :titles="'تعریف کار'"/>
    <div class="row">
      <div class="col-md-4 col-sm-6 col-12">
        <div class="mb-2">عنوان:</div>
        <v-text-field
            solo
            dense
            v-model="subject"
            flat
            hide-details
            color="primary"
            placeholder="عنوان را وارد کنید">
        </v-text-field>
        <div v-if="subject === null" class="validator font12px mt-1 mr-1">پر کردن این فیلد اجباریست.</div>
      </div>
      <div class="col-md-4 col-sm-6 col-12">
        <div class="mb-2">دسته بندی:</div>
        <v-autocomplete
            solo
            flat
            dense
            hide-details
            color="primary"
            :items="categoryItems"
            v-model="categoryModel"
            item-text="Name"
            item-value="AssignmentCategoryId"
            placeholder="دسته بندی را انتخاب کنید">
        </v-autocomplete>
        <div v-if="categoryModel === null" class="validator font12px mt-1 mr-1">پر کردن این فیلد اجباریست.</div>

      </div>
      <div class="col-md-4 col-sm-6 col-12">
        <div class="mb-2">کاربر:</div>
        <v-autocomplete
            solo
            flat
            dense
            hide-details
            color="primary"
            :items="UserItems"
            v-model="userModel"
            item-text="fullName"
            item-value="ID"
            placeholder="کاربر را انتخاب کنید">
        </v-autocomplete>
        <div v-if="userModel === null" class="validator font12px mt-1 mr-1">پر کردن این فیلد اجباریست.</div>

      </div>
      <div class="col-12">
        <div class="my-2">فایل: (شما میتوانید 5 فایل یا کمتر آپلود کنید)</div>
        <div class="row">
          <div class="col">
            <v-file-input id="fileInput1"
                          name="fileInput1" placeholder="فایل1" show-size solo flat dense hide-details
                          append-icon="fa-paperclip"
                          prepend-icon=""></v-file-input>
          </div>
          <div class="col">
            <v-file-input id="fileInput2"
                          name="fileInput2" placeholder="فایل2" solo flat dense hide-details append-icon="fa-paperclip"
                          prepend-icon=""></v-file-input>
          </div>
          <div class="col">
            <v-file-input
                id="fileInput3"
                name="fileInput3" placeholder="فایل3" solo flat dense hide-details append-icon="fa-paperclip"
                prepend-icon=""></v-file-input>
          </div>
          <div class="col">
            <v-file-input id="fileInput4"
                          name="fileInput4" placeholder="فایل4" solo flat dense hide-details append-icon="fa-paperclip"
                          prepend-icon=""></v-file-input>
          </div>
          <div class="col">
            <v-file-input id="fileInput5"
                          name="fileInput5" placeholder="فایل5" solo flat dense hide-details append-icon="fa-paperclip"
                          prepend-icon=""></v-file-input>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="mb-2">توضیحات:</div>
        <editor-content :editor="description" class="text-editor"/>
        <div v-if="description !== null && description.getHTML() === '<p></p>'" class="validator font12px mt-1 mr-1">پر کردن این فیلد اجباریست.</div>
      </div>
      <div class="col-6">
        <div class="mb-2">تاریخ و زمان تحویل:</div>
        <div class="row">
          <div class="col-6">
            <div class="mb-1">تاریخ تحویل:</div>
            <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                min-width="auto"
                offset-y
                transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="inputDate2"
                    v-bind="attrs"
                    v-on="on"
                    class="input-border"
                    color="secondary"
                    dense
                    flat
                    hide-details
                    readonly
                    solo>
                </v-text-field>
              </template>
              <v-date-picker
                  v-model="date2"
                  color="secondary"
                  locale="fa-ir"
                  width="256"
                  @input="inputDatePicker2"></v-date-picker>
            </v-menu>
          </div>
          <div class="col-6">
            <div class="mb-1">ساعت تحویل:</div>
            <div>
              <v-menu
                  ref="menu"
                  v-model="menuTime2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="time"
                      class="input-border"
                      readonly
                      dense
                      flat
                      solo
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                    v-if="menuTime2"
                    v-model="time"
                    full-width
                    @click:minute="$refs.menu.save(time)"
                ></v-time-picker>
              </v-menu>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 text-center align-self-end">
        <v-btn :disabled="categoryModel === null || userModel === null || subject === null || description.getHTML() === '<p></p>'" solo
               elevation="0" color="primary" class="cards-btn" @click="defineTask">انجام
        </v-btn>
      </div>
    </div>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="530">
      <v-card class="text-center">
        <v-card-title class="justify-space-between primary-bg">
          <v-btn
              color="primary"
              icon
              small
              @click="showResultDialog = false"
          >
            <i class="fas fa-times font-16 ml-1"></i>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <div class="mb-0 black--text py-5">{{ dialogResult }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import NavigationDrawer from "@/Admin/components/navigationDrawer";
import {Editor, EditorContent} from "tiptap";
import moment from "moment-jalaali";

export default {
  name: "defineTask",
  components: {NavigationDrawer, EditorContent},
  metaInfo() {
    return {
      title: 'ادمین - تعریف کار'
    }
  },
  data: () => ({
    menu2: false,
    date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    inputDate2: "",
    isNew: true,
    isActive: false,
    showResultDialog: false,
    title: null,
    dialogResult: null,
    subject: null,
    userModel: null,
    description: null,
    newsTitle: null,
    categoryModel: null,
    datetime: null,
    DeliveryDate: null,
    RecallDate: null,
    categoryItems: [],
    UserItems: [],
    time: null,
    menuTime2: false,
    showLoaderDialog: false,
  }),
  mounted() {
    let current = new Date();
    current.setDate(current.getDate() - 60);
    let currentTime = new Date();
    currentTime.setTime(currentTime.getTime())
    let tmpTime= currentTime.toString().split(" ")[4].split(":");
    this.time = tmpTime[0] + ":" + tmpTime[1];
    this.inputDate2 = this.$convertDate(this.date2);
    this.description = new Editor({
      content: '',
    })

    this.getTasksCategory()
    this.getAllUsers()
  },
  methods: {
    inputDatePicker2() {
      this.menu2 = false;
      this.inputDate2 = moment(this.date2).format("jYYYY/jMM/jDD");
    },
    getTasksCategory() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/AssignmentCategoriesList", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.categoryItems = JSON.parse(result)
            console.log(this.categoryItems)
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    defineTask() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("Subject", this.subject);
      formdata.append("Description", this.description.getHTML());
      formdata.append("AssignmentCategoryId", this.categoryModel);
      formdata.append("AppUserId", this.userModel);
      if (document.getElementById('fileInput1').files[0] !== undefined) {
        formdata.append("File1", document.getElementById('fileInput1').files[0]);
      }
      if (document.getElementById('fileInput2').files[0] !== undefined) {
        formdata.append("File2", document.getElementById('fileInput2').files[0]);
      }
      if (document.getElementById('fileInput3').files[0] !== undefined) {
        formdata.append("File3", document.getElementById('fileInput3').files[0]);
      }
      if (document.getElementById('fileInput4').files[0] !== undefined) {
        formdata.append("File4", document.getElementById('fileInput4').files[0]);
      }
      if (document.getElementById('fileInput5').files[0] !== undefined) {
        formdata.append("File5", document.getElementById('fileInput5').files[0]);
      }
      formdata.append("DeliveryDateString", this.inputDate2 + "T" + this.time);

      for (const [key, value] of formdata.entries()) {
        console.log(key, value)
      }


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/NewAssignment", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.dialogResult = result
            this.showResultDialog = true
            this.showLoaderDialog = false
            this.$router.push({path: 'listTasks'})
          })
          .catch(error => console.log('error', error));
    },
    getAllUsers() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/ListPersonnel", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            console.log("users")
            console.log(json)
            this.UserItems = json
            for (let i = 0; i < json.length; i++) {
              json[i].fullName = json[i].Name + " " + json[i].Family;
            }
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
  }
}
</script>

<style scoped>

</style>